import {
  Alert,
  Button,
  Checkbox,
  Label,
  Modal,
  TextInput,
} from 'flowbite-react';
import { useState } from 'react';
import { LoginRequest } from '../../Models/LoginRequest';
import AuthApi from '../../Api/AuthApi';
import { jwtDecode } from 'jwt-decode';
import { DecodedToken } from '../../Models/DecodedToken';
import { useAppDispatch } from '../../Reducers/store';
import { fetchCurrentUser, setUserFromToken } from '../../Actions';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import PBLogo from '../../Assets/fuelpro-logo.png';
import { Link, useNavigate } from 'react-router-dom';
import React from 'react';

export default function Login() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [formData, setFormData] = useState<LoginRequest>({
    email: '',
    password: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      setShowError(false);
      setIsLoading(true);
      return AuthApi.login(formData)
        .then((res) => {
          localStorage.setItem('FuelProToken', res.data);
          const decoded: DecodedToken = jwtDecode(res.data);
          dispatch(
            setUserFromToken({
              email:
                decoded[
                  'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'
                ],
              exp: decoded.exp,
            })
          );
          dispatch(fetchCurrentUser());
          toast.success('Success!');
          setIsLoading(false);
          navigate('/');
        })
        .catch((err) => {
          setShowError(true);
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  return (
    <>
      <div className=''>
        {isLoading && <Loader />}
        <div className='flex flex-col items-center justify-center px-6 mx-auto'>
          <a
            href='/'
            className='flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white'
          >
            <img className='h-20 mr-2' src={PBLogo} alt='logo'></img>
          </a>
          <div className='w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700'>
            <div className='px-6 pt-6 space-y-4 md:space-y-6'>
              <div className='flex flex-col items-center justify-center'>
                <h1 className='text-xl font-bold text-gray-900 md:text-2xl dark:text-white'>
                  Sign in to your account
                </h1>
              </div>
              <form
                className='flex max-w-md flex-col gap-4'
                onSubmit={onSubmit}
              >
                <div>
                  <div className='mb-2 block'>
                    <Label htmlFor='email' value='Your email' />
                  </div>
                  <TextInput
                    id='email'
                    name='email'
                    type='email'
                    placeholder='your@email.com'
                    onChange={handleChange}
                    value={formData.email}
                    required
                  />
                </div>
                <div>
                  <div className='mb-2 block'>
                    <Label htmlFor='pass' value='Your password' />
                  </div>
                  <TextInput
                    id='pass'
                    name='password'
                    type='password'
                    onChange={handleChange}
                    value={formData.password}
                    required
                  />
                </div>
                {showError && (
                  <Alert color='failure'>Authorization Failed!</Alert>
                )}
                <Button type='submit' className='buttonMain'>
                  Submit
                </Button>
              </form>
            </div>
            <div className='flex justify-between p-2'>
              <Link
                to='/register'
                className='hover:underline'
                style={{ color: 'blue' }}
              >
                Register
              </Link>
              <Link
                to='/forgotpassword'
                className='hover:underline'
                style={{ color: 'blue' }}
              >
                Forgot Password?
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
